import { h, ComponentType, JSX, Ref } from "preact";

import classname from "../../../../foundation/utils/classname";
import IconArrowDown from "../../Icons/IconArrowDown";
import IconProps from "../../Icons/IconProps";

import styles from "./DropdownButton.module.css";

type NativeButtonProps = Omit<JSX.HTMLAttributes<HTMLButtonElement>, "icon">;

interface Props extends NativeButtonProps {
    buttonRef?: Ref<HTMLButtonElement>;
    textClass?: string;
    childrenClass?: string;
    class?: string;
    icon?: ComponentType<IconProps> | null;
    showChevron?: boolean;
    activated?: boolean;
    onClick?: (event: MouseEvent) => void;
}

export default function DropdownButton({
    buttonRef,
    class: cssClass,
    textClass = "body-1",
    childrenClass,
    children,
    icon: Icon,
    showChevron = true,
    activated,
    onClick,
    ...nativeButtonProps
}: Props) {
    const onlyIcon = !children && (!Icon || !showChevron);

    return (
        <button
            {...nativeButtonProps}
            ref={buttonRef}
            className={classname(styles.dropdownButton, cssClass, {
                [styles.activated]: activated,
                [styles.onlyIcon]: onlyIcon
            })}
            onClick={onClick}>
            {Icon && <Icon/>}
            {children &&
                <span class={classname(styles.children, childrenClass, textClass, "ellipsis")}>{children}</span>}
            {showChevron && <IconArrowDown class={styles.chevron}/>}
        </button>
    );
}

export {
    Props as DropdownButtonProps
};
